import Axios from 'axios';
import { handleError } from '@/_helpers/utils.js';

export default {
  namespaced: true,

  state() {
    return {
      item: {},
      loaded: false,
      error: false
    };
  },

  actions: {
    fetch({ commit }, id) {
      commit('setLoaded', false);
      return Axios.get(`/1.0/responses/${id}/test`)
        .then(response => {
          commit('setItem', response.data.data[0]);
          commit('setLoaded', true);
          return response;
        })
        .catch(error => {
          error = handleError(error);
          commit('setError', error);
          commit('setLoaded', true);
          throw error;
        });
    }
  },

  mutations: {
    setError(state, error) {
      state.error = error;
    },

    setItem(state, item) {
      state.item = item;
    },

    setLoaded(state, loaded) {
      state.loaded = loaded;
    }
  },

  getters: {
    item: state => state.item,
    loaded: state => state.loaded,
    error: state => state.error,
    calculateTestStatus: state => state.item.result && state.item.result.calculate_test_status,
    hasPassed: state => state.item.result && state.item.result.passed
  }
};
